import { isAfter } from 'date-fns';
import { useSelector } from 'react-redux';

import { selectEtazhiBlackFridayPromoOffersData } from 'shared/selectors/etazhiBlackFriday';

export function usePromoOffersVisibility() {
  const promoOffersData = useSelector(selectEtazhiBlackFridayPromoOffersData);
  const isPromoOffersVisible = !!promoOffersData?.enabled;
  const visibilityTimestamp = promoOffersData?.startDate ?? null;

  if (!isPromoOffersVisible) {
    return false;
  }

  /**
   * Нужно будет расширить проверкой на наличие офферов в "Полке" под кампанию к ЧП.
   */
  const isEtazhiPromoOffersAvailable = true;

  if (!visibilityTimestamp) {
    return isEtazhiPromoOffersAvailable;
  }

  const startDate = new Date(visibilityTimestamp);
  const now = new Date();

  const isStartDatePassed = isAfter(now, startDate);

  return isEtazhiPromoOffersAvailable && isStartDatePassed;
}
